import { motion } from 'framer-motion';
import { useI18n } from '../../context/I18nContext';
import ImageOnlySkeletonLoader from '../ImageOnlySkeletonLoader';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.14,
      delayChildren: 0.08,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] },
  },
};

export default function AboutVideoBannerSection() {
  const { t } = useI18n();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[56vh] min-h-[420px] w-full md:h-[62vh] md:min-h-[520px]">
        <ImageOnlySkeletonLoader
          mode="video"
          videoSources={[{ src: '/videos/1.mp4', type: 'video/mp4' }]}
          containerClassName="absolute inset-0"
          videoClassName="absolute inset-0 h-full w-full object-cover"
          aria-hidden="true"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/45 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-black/20" />

        <div className="relative z-10 flex h-full items-center">
          <div className="container mx-auto px-6 lg:px-12">
            <motion.div
              className="max-w-xl text-white"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-120px' }}
            >
              <motion.h2 variants={itemVariants} className="text-4xl font-light uppercase leading-tight sm:text-5xl">
                <span className="block">{t('aboutPage.videoBanner.titleLine1', 'Built For')}</span>
                <span className="block font-black text-[var(--dash-other)]">
                  {t('aboutPage.videoBanner.titleLine2', 'Daily Reliability')}
                </span>
              </motion.h2>
              <motion.p className="mt-5 text-sm font-light leading-relaxed text-white/85 sm:text-base lg:text-lg" variants={itemVariants}>
                {t(
                  'aboutPage.videoBanner.description',
                  'From equipment selection to spare parts, ETC supports operational continuity for warehouses and industrial teams.',
                )}
              </motion.p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
